import { Box, Stack, Typography } from "@mui/material";
import { useTenant } from "../../../contexts/TenantContext";
import { tint } from "../../../utils/textStyles";
import ProviderAvatar from "./ProviderAvatar";

/**
 * The avatar, then the tenant's word for a provider („Borbély”) above the name. The
 * name has a line of its own, so a long one wraps instead of being cut off after the label.
 * `provider` undefined draws the „Bárki” avatar.
 */
const ProviderTag = ({ provider, name, fontSize = 14, avatarSize = 36, testId, sx }) => {
  const { displayConfig } = useTenant();
  const textColor = displayConfig?.color;

  return (
    <Stack direction="row" alignItems="center" spacing={1.25} minWidth={0} data-testid={testId} sx={sx}>
      <Box flexShrink={0} display="flex">
        <ProviderAvatar provider={provider} size={avatarSize} />
      </Box>
      <Box minWidth={0}>
        <Typography fontSize={fontSize * 0.85} lineHeight={1.3} sx={{ color: tint(textColor, 0.66) }}>
          {displayConfig?.providerLabel}
        </Typography>
        <Typography fontSize={fontSize} fontWeight={700} lineHeight={1.3}
          sx={{ color: textColor, overflowWrap: "anywhere" }}>
          {name}
        </Typography>
      </Box>
    </Stack>
  );
};

export default ProviderTag;
